import * as React from "react";
import { Redirect, useLocation } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import {
    API_KEYS_ROUTE,
    BAM_API_KEYS_ROUTE,
    deriveRedirectTarget,
    detectApplicationFromPath,
} from "components/router/Routes";
import { Application } from "store/application";

export default function ApiKeysView(): JSX.Element {
    const { pathname } = useLocation();
    const isRouteEnabled = useIsRouteEnabled();

    const route = detectApplicationFromPath(pathname) === Application.BAM ? BAM_API_KEYS_ROUTE : API_KEYS_ROUTE;
    const target = deriveRedirectTarget(route, isRouteEnabled);

    return <Redirect to={target.path} />;
}
